export default function Phone() {
    return (
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_608_33147)">
                <path
                    d="M13.0348 22.4627C13.5136 22.4627 13.9017 22.0746 13.9017 21.5959C13.9017 21.1171 13.5136 20.729 13.0348 20.729C12.5561 20.729 12.168 21.1171 12.168 21.5959C12.168 22.0746 12.5561 22.4627 13.0348 22.4627Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="0.458317"
                />
                <path d="M11.6924 5.1416H14.377" stroke="black" strokeWidth="0.812497" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M17.1137 2.98242H8.95565C7.69004 2.98242 6.66406 4.0084 6.66406 5.27401V22.1401C6.66406 23.4057 7.69004 24.4316 8.95565 24.4316H17.1137C18.3793 24.4316 19.4053 23.4057 19.4053 22.1401V5.27401C19.4053 4.0084 18.3793 2.98242 17.1137 2.98242Z"
                    stroke="black"
                    strokeWidth="0.812497"
                />
            </g>
            <defs>
                <clipPath id="clip0_608_33147">
                    <rect width="25.9999" height="25.9999" fill="white" transform="translate(0.0458984 0.707031)" />
                </clipPath>
            </defs>
        </svg>
    );
}
